import React, { useState, useEffect, useCallback, useRef } from "react";

const YouTubeResponsiveEmbed = (props) => {
  const { videoId, autoPlay, title, maxHeight = 495 } = props; // Set a default value for maxHeight
  // Build the video URL with autoplay support
  let videoURL = `https://www.youtube.com/embed/${videoId}`;
  if (autoPlay) {
    videoURL += "?autoplay=1";
  }
  const iframeRef = useRef(null);
  const defaultHeight = 200;
  const [videoHeight, setVideoHeight] = useState(
    iframeRef.current
      ? Math.min(iframeRef.current.offsetWidth * 0.5625, maxHeight)
      : defaultHeight
  );

  const handleChangeVideoWidth = useCallback(() => {
    const ratio =
      window.innerWidth > 990
        ? 1.0
        : window.innerWidth > 522
        ? 1.2
        : window.innerWidth > 400
        ? 1.45
        : 1.85;
    const height = iframeRef.current
      ? Math.min(iframeRef.current.offsetWidth * 0.5625, maxHeight)
      : defaultHeight;
    return setVideoHeight(Math.floor(height * ratio));
  }, [maxHeight]);

  useEffect(() => {
    window.addEventListener("resize", handleChangeVideoWidth);
    handleChangeVideoWidth(); // Ensure that the initial size respects the maxHeight
    return function cleanup() {
      window.removeEventListener("resize", handleChangeVideoWidth);
    };
  }, [handleChangeVideoWidth]);

  return (
    <iframe
      ref={iframeRef}
      title={title}
      width="100%"
      height={`${videoHeight}px`}
      src={videoURL}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen={true}
    />
  );
};

export default YouTubeResponsiveEmbed;
